const SelectMenu = ({ menuList, formik, name }: any) => {
  return (
    <div className="d-flex">
      {menuList?.map((value: any, index: number) => (
        <div
          key={index}
          className="user-select-none d-flex"
          style={{
            // padding: "10px",
            background: value?.checked ? "#007bff" : "#fff",
            color: value?.checked ? "#fff" : "#000",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "5px",
            textAlign: "center",
            height: "44px",
            margin: "0 10px",
            border: "1px solid #ddd",
            borderColor: "#007bff",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "0 20px",
              height: "100%",
              cursor: "pointer",
            }}
            onClick={() => {
              formik.setFieldValue(
                `${name}.[${index}].checked`,
                !value?.checked
              );
            }}
          >
            {value?.icon && value?.iconEnable && (
              <img
                alt="iconMenu"
                src={!value?.checked ? value?.icon : value?.iconEnable}
                style={{ height: "20px", stroke: "red" }}
              />
            )}
            <p style={{ margin: 0 }}>{value?.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SelectMenu;
